module.exports = __webpack_public_path__ + "static/media/banner.3539d5bc.jpg";